export type Alignment = 'left' | 'center' | 'right';

const alignmentStyles: Record<string, string> = {
  left: 'lg:order-0',
  right: 'lg:order-1',
};
const alignmentSecodaryStyles: Record<string, string> = {
  left: 'lg:order-1',
  right: 'lg:order-0',
};
export function useAlignmentClass(alignment?: Alignment) {
  return alignment ? alignmentStyles[alignment] : '';
}
export function useAlignmentSecondaryClass(alignment?: Alignment) {
  return alignment ? alignmentSecodaryStyles[alignment] : '';
}
